module.exports = __webpack_public_path__ + "img/clean_verb.be5030ca.webp";